/**
 * Configuración de la web, resuelta en build (Vite). Con VITE_DEV_TOKEN la web
 * entra en modo desarrollo contra la API mock: en `npm run dev` aunque
 * `.env.local` tenga Supabase (los E2E y la API mock siguen funcionando); en un
 * build, solo si no hay Supabase (un token de prueba nunca gana en producción).
 */
const env = import.meta.env

export const CONFIG = {
  apiUrl: (env.VITE_API_URL ?? 'http://localhost:8787').replace(/\/$/, ''),
  supabaseUrl: env.VITE_SUPABASE_URL ?? '',
  supabaseAnonKey: env.VITE_SUPABASE_ANON_KEY ?? '',
  /** IDs de la extensión por tienda (Chrome, Edge, desarrollo): se prueban en orden. */
  extensionIds: (env.VITE_EXTENSION_IDS ?? 'lgonmoecnnepgjibmhgnfkjpbhfiaojb')
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean),
  devToken: env.VITE_DEV_TOKEN ?? '',
  version: env.VITE_VERSION ?? '0.0.1'
}

export const DEV_MODE = Boolean(CONFIG.devToken) && (env.DEV || !CONFIG.supabaseUrl)
